import { typeArticles } from "./articles"
import { queryAdmTopArticles } from "./queries/queryAdmTopArticles"
import { queryArticle } from "./queries/queryArticle"
import { queryArticleNotices } from "./queries/queryArticleNotices"
import { queryArticleQuerySuggestions } from "./queries/queryArticleQuerySuggestions"
import { queryArticles } from "./queries/queryArticles"
import { queryArticlesSearch } from "./queries/queryArticlesSearch"
import { queryBundle } from "./queries/queryBundle"
import { queryBundleImage } from "./queries/queryBundleImage"
import { queryBundles } from "./queries/queryBundles"
import { queryCustomerTopArticles } from "./queries/queryCustomerTopArticles"
import { querySuggestedAlgoliaArticles } from "./queries/querySuggestedAlgoliaArticles"

const articleSchema = {
  types: [typeArticles],
  resolvers: {
    Query: {
      ...queryArticle,
      ...queryArticles,
      ...queryArticleNotices,
      ...queryAdmTopArticles,
      ...queryCustomerTopArticles,
      ...queryArticlesSearch,
      ...queryArticleQuerySuggestions,
      ...querySuggestedAlgoliaArticles,
      ...queryBundle,
      ...queryBundles,
      ...queryBundleImage,
    },
    Mutation: {},
  },
}

export default articleSchema
